import { ProductionFulfillmentApi, useAPIQuery } from "melco-shared-logic";

export const useDataMappingDropdownData = (inputFormatId: string) => {
  return useAPIQuery(
    ProductionFulfillmentApi,
    ["dataMappingDropdownData", inputFormatId],
    async (api) => {
      const response = await api.productionFulfillmentMappingsGetList({
        formatId: inputFormatId,
        offset: 0,
        limit: 100,
        sortBy: "name.asc",
        global: true,
      });

      return response.list;
    },
    {
      queryOptions: {
        keepPreviousData: true,
      },
    }
  );
};
